export default "__VITE_ASSET__4fdadb4c__"